export { default } from './ConditionRatingsDay';
